import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useIsMobile, Stack, AssistChip } from '@hub-la/design-system';
import { CircularProgress } from '@mui/material';
import { Fragment as Fragment$1 } from 'react';
import { Comment } from '../components/comment/comment.js';
import { Count } from '../components/count/count.js';
import { InputComment } from '../components/input-comment/input-comment.js';
import { useGetComments } from '../hooks/use-get-comments.js';
import { usePostComment } from '../hooks/use-post-comment.js';
import { DiscussionProvider, useDiscussion } from '../providers/discussion.js';

const DiscussionContent = ({
  currentUser
}) => {
  var _a, _b, _c;
  const isMobile = useIsMobile();
  const {
    metadata,
    orderDir
  } = useDiscussion();
  const {
    data,
    isLoading: isLoadingComments,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage
  } = useGetComments({
    postId: metadata.postId,
    pageSize: isMobile ? 5 : 10,
    orderDir
  });
  const {
    mutateAsync,
    isLoading
  } = usePostComment({
    currentUser
  });
  const totalComments = (_b = (_a = data === null || data === void 0 ? void 0 : data.pages[0]) === null || _a === void 0 ? void 0 : _a.total) !== null && _b !== void 0 ? _b : 0;
  return jsxs(Fragment, {
    children: [jsx(Count, {
      total: totalComments,
      isLoading: isLoadingComments
    }), jsxs(Stack, Object.assign({
      width: "100%",
      gap: 6
    }, {
      children: [jsx(InputComment, {
        onComment: message => __awaiter(void 0, void 0, void 0, function* () {
          yield mutateAsync({
            message,
            postId: metadata.postId
          });
        }),
        isLoading: isLoading,
        avatarUrl: currentUser === null || currentUser === void 0 ? void 0 : currentUser.picture
      }), isLoadingComments && jsx(Stack, Object.assign({
        direction: "row",
        justifyContent: "center",
        width: "100%",
        color: "#fff"
      }, {
        children: jsx(CircularProgress, {
          color: "inherit"
        })
      })), ((_c = data === null || data === void 0 ? void 0 : data.pages) !== null && _c !== void 0 ? _c : []).map((group, i) => {
        var _a;
        return jsx(Fragment$1, {
          children: (_a = group === null || group === void 0 ? void 0 : group.items) === null || _a === void 0 ? void 0 : _a.map(comment => {
            var _a, _b;
            return jsx(Comment, {
              commentId: comment.id,
              fullName: (_a = comment === null || comment === void 0 ? void 0 : comment.user) === null || _a === void 0 ? void 0 : _a.name,
              avatarUrl: (_b = comment === null || comment === void 0 ? void 0 : comment.user) === null || _b === void 0 ? void 0 : _b.picture,
              createdAt: comment.createdAt,
              comment: comment.message,
              isLiked: comment.hasUserLike,
              likes: comment.likesCount,
              repliesCount: comment.repliesCount,
              latestReplyAt: comment.latestReplyAt,
              isEdited: comment.wasEdited,
              userId: comment === null || comment === void 0 ? void 0 : comment.userId,
              hasOwnerReply: comment.hasOwnerReply,
              discussionOwner: comment === null || comment === void 0 ? void 0 : comment.discussionOwner
            }, comment.id);
          })
        }, i);
      }), hasNextPage && jsx(AssistChip, {
        variant: "outlined",
        label: "Ver mais coment\u00E1rios",
        onClick: () => fetchNextPage(),
        disabled: isFetchingNextPage
      })]
    }))]
  });
};
const Discussion = ({
  discussionOwnerId,
  currentUser,
  type,
  metadata
}) => {
  return jsx(DiscussionProvider, Object.assign({
    discussionOwnerId: discussionOwnerId,
    currentUser: currentUser,
    type: type,
    metadata: metadata
  }, {
    children: jsx(DiscussionContent, {
      currentUser: currentUser,
      metadata: metadata,
      type: type,
      discussionOwnerId: discussionOwnerId
    })
  }));
};

export { Discussion };
